import memoize from 'lodash/memoize';
import React, { type ReactNode } from 'react';
import { type MapStateToProps, connect } from 'react-redux';

import { TunerVars } from '../../../utils/index';
import * as D from '../deps';

import BackstageAlbum from './BackstageAlbum';
import BackstageArtist from './BackstageArtist';
import BackstageTrack from './BackstageTrack';
import BackstageArtist2 from './pages/BackstageArtist2/BackstageArtist';
import BackstageCurator from './pages/BackstageCurator/BackstageCuratorDataFetcher';

const log = D.Logger.child({ component: 'domains/backstage/components/Backstage' }, true);

export interface IBackstageStateProps {
  isCuratorExperienceEnabled: ReturnType<typeof TunerVars.curatorExperienceEnabled>;
}

export interface IBackstageOwnProps
  extends React.PropsWithChildren<{
    // These params properties are tokens coming from urls matched and parsed by react-router
    // and they are positional, thus their names. We only determine their purpose after this
    // component is instantiated.
    location: {
      pathname: string;
    };
    // eslint-disable-next-line react-redux/no-unused-prop-types
    params: {
      seoToken1: string;
      seoToken2: string;
      seoToken3: string;
      seoToken4: string;
      pandoraId: string;
    };
  }> {}

export type IBackstageProps = IBackstageStateProps & IBackstageOwnProps;

const memoizeParams = memoize(
  (props: IBackstageProps) => {
    const path = props.location.pathname;
    const { seoToken1, seoToken2, seoToken3, seoToken4, pandoraId } = props.params;
    const isCuratorPath =
      D.Utils.Route.isBackstageCuratorPath(path) || D.Utils.Route.isBackstageCuratorChildPath(path);
    const params = isCuratorPath ? { curatorSeoToken: seoToken1 } : { artistSeoToken: seoToken1 };

    if (D.Utils.Route.isBackstageArtistPath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = seoToken2;
    } else if (D.Utils.Route.isBackstageAlbumPath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'albumSeoToken' does not exist on type '{... Remove this comment to see the full error message
      params.albumSeoToken = seoToken2;
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = seoToken3;
    } else if (D.Utils.Route.isBackstageTrackPath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'albumSeoToken' does not exist on type '{... Remove this comment to see the full error message
      params.albumSeoToken = seoToken2;
      // @ts-expect-error TS(2339) FIXME: Property 'trackSeoToken' does not exist on type '{... Remove this comment to see the full error message
      params.trackSeoToken = seoToken3;
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = seoToken4;
    } else if (D.Utils.Route.isBackstageArtistChildPagePath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = pandoraId;
    } else if (D.Utils.Route.isBackstageAlbumChildPagePath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = pandoraId;
    } else if (D.Utils.Route.isBackstageTrackChildPagePath(path)) {
      // @ts-expect-error TS(2339) FIXME: Property 'albumSeoToken' does not exist on type '{... Remove this comment to see the full error message
      params.albumSeoToken = seoToken2;
      // @ts-expect-error TS(2339) FIXME: Property 'trackSeoToken' does not exist on type '{... Remove this comment to see the full error message
      params.trackSeoToken = seoToken3;
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = pandoraId;
    } else if (isCuratorPath) {
      // @ts-expect-error TS(2339) FIXME: Property 'pandoraId' does not exist on type '{ art... Remove this comment to see the full error message
      params.pandoraId = pandoraId;
    }
    return params;
  },
  props => props.location.pathname,
);

export class Backstage extends React.Component<IBackstageProps> {
  render(): ReactNode {
    const path = this.props.location.pathname;
    const params = memoizeParams(this.props);
    if (D.Utils.Route.isBackstageArtistPath(path)) {
      return this.props.isCuratorExperienceEnabled ? (
        <BackstageArtist2 params={params} />
      ) : (
        <BackstageArtist params={params} />
      );
    } else if (D.Utils.Route.isBackstageAlbumPath(path)) {
      return <BackstageAlbum params={params} />;
    } else if (D.Utils.Route.isBackstageTrackPath(path)) {
      return <BackstageTrack params={params} />;
    } else if (D.Utils.Route.isBackstageArtistChildPagePath(path)) {
      return this.props.isCuratorExperienceEnabled ? (
        <BackstageArtist2 params={params}>{this.props.children}</BackstageArtist2>
      ) : (
        <BackstageArtist params={params}>{this.props.children}</BackstageArtist>
      );
    } else if (D.Utils.Route.isBackstageAlbumChildPagePath(path)) {
      return <BackstageAlbum params={params}>{this.props.children}</BackstageAlbum>;
    } else if (D.Utils.Route.isBackstageTrackChildPagePath(path)) {
      return <BackstageTrack params={params}>{this.props.children}</BackstageTrack>;
    } else if (D.Utils.Route.isBackstageCuratorPath(path)) {
      return <BackstageCurator params={params} />;
    } else if (D.Utils.Route.isBackstageCuratorChildPath(path)) {
      return <BackstageCurator params={params}>{this.props.children}</BackstageCurator>;
    }

    log.warn(`Could not find backstage path ${path}`);

    return null;
  }
}

export const mapStateToProps: MapStateToProps<
  IBackstageStateProps,
  IBackstageOwnProps,
  $TSFixMe
> = state => {
  return { isCuratorExperienceEnabled: TunerVars.curatorExperienceEnabled(state) };
};

export default connect(mapStateToProps)(Backstage);
